/** Production API (no secrets — safe to default in PROD builds). */
export const PRODUCTION_API_ORIGIN = 'https://api.canadawaleyar.com';
export const PRODUCTION_API_BASE_URL = `${PRODUCTION_API_ORIGIN}/api`;

interface ApiConfig {
  baseUrl: string;
  env: 'local' | 'development' | 'production';
}

/**
 * REST base URL (includes `/api`).
 * Order: VITE_API_BASE_URL → VITE_API_URL + /api → PROD default → localhost.
 */
export function resolveApiBaseUrl(): string {
  const explicit = import.meta.env.VITE_API_BASE_URL?.trim();
  if (explicit) {
    return explicit.replace(/\/$/, '');
  }
  const origin = import.meta.env.VITE_API_URL?.trim();
  if (origin) {
    const o = origin.replace(/\/$/, '');
    if (o.endsWith('/api')) return o;
    return `${o}/api`;
  }
  if (import.meta.env.PROD) {
    return PRODUCTION_API_BASE_URL;
  }
  return 'http://localhost:3000/api';
}

/**
 * Socket.IO / WebRTC host (no `/api` path).
 */
export function resolveSocketOrigin(): string {
  const direct = import.meta.env.VITE_API_URL?.trim();
  if (direct) {
    return direct.replace(/\/$/, '');
  }
  const base = resolveApiBaseUrl();
  if (base.endsWith('/api')) {
    return base.slice(0, -4);
  }
  return base.replace(/\/$/, '');
}

const getApiConfig = (): ApiConfig => {
  const env = import.meta.env.MODE;
  return {
    baseUrl: resolveApiBaseUrl(),
    env: env as 'local' | 'development' | 'production',
  };
};

export const apiConfig = getApiConfig();
